import {
  Component,
  OnInit,
  OnChanges,
  AfterContentInit,
  ViewChild,
  Output,
  EventEmitter,
  Input,
  HostListener,
  ChangeDetectionStrategy
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppGlobals } from '../../app.globals';
import { ContactsService } from '../../services/contacts.service';
import { CommonModule, Location, NgIf } from '@angular/common';
import { confirm, custom } from 'devextreme/ui/dialog';
import { AuthService } from 'src/app/services/auth.service';

import {
  DxAutocompleteModule,
  DxButtonComponent,
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxFileUploaderModule,
  DxFormComponent,
  DxCheckBoxModule,
  DxFormModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTemplateModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToastModule,
  DxTreeViewModule,
  DxValidationGroupModule,
  DxValidatorComponent,
  DxValidatorModule,
} from 'devextreme-angular';
import { type } from 'os';
import { truncate } from 'fs';
import { SharedComponentsModule } from '../shared.components.module';
import { ProjectCostsService } from 'src/app/services/project-costs.service';
import { ClickEvent } from 'devextreme/ui/button';
import { ContactsAddCompanyComponent } from '../contacts-add-company/contacts-add-company.component';
import { ContactsDropdownBoxComponent } from '../contacts-dropdown-box/contacts-dropdown-box.component';
import { ContactService } from 'src/app/services/contact.service';
import { ProjectTaskStatusConfig, StatusData } from 'src/app/constants/Status';
import { ContactsPopupComponent } from '../contacts-popup/contacts-popup.component';
import { ProjectCostTemplatesService } from 'src/app/services/project-cost-templates.service ';
import { ProjectService } from 'src/app/services/project.service';
import { GlobalPopupService } from 'src/app/components/generic-popup/presets/global-popup/global-popup.service';
import { Button } from 'protractor';
import { GpdButtonComponent } from '../gpd-button/gpd-button.component';
import { SearchableDropdownDirective } from '../../directives/searchable-dropdown.directive';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { ProjectCostRole, missingResponsibleDepartment } from './project-cost-roles';
@Component({
    selector: 'app-projektkosten-pop-up',
    templateUrl: './projektkosten-pop-up.component.html',
    styleUrls: ['./projektkosten-pop-up.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        SvgIconComponent,
        DxDataGridModule,
        DxTagBoxModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxToastModule,
        SharedComponentsModule,
        DxNumberBoxModule,
        DxFormModule,
        DxPopupModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxAutocompleteModule,
        DxDateBoxModule,
        DxTextAreaModule,
        DxValidationGroupModule,
        DxValidatorModule,
        ContactsAddCompanyComponent,
        ContactsDropdownBoxComponent,
        ContactsPopupComponent,
        DxCheckBoxModule,
        DxTemplateModule,
        DxFileUploaderModule,
        GpdButtonComponent,
        SearchableDropdownDirective,
    ]
})
export class ProjektkostenPopUpComponent implements OnInit, OnChanges, AfterContentInit {
  treeDataSource: any;
  treeDataSourceSorted: any = [];
  categoryDisabled: boolean = true;
  message: any = '';
  type: any = '';
  toastVisible: boolean = false;

  deleteButtonVisible: boolean = true;

  totalPercentageCalc: any = 0;

  totalDueCalc: any = 0;

  isTreeBoxOpened: boolean = false;

  removePaymentPlanButtonVisible: boolean = false;

  @Input() categoryList: any = [];

  @Input() partnerList: any = [];

  @Input() projectDetails: any = '';

  /** The project's department roles; a cost needs somebody in the role of its category's department (#4954). */
  @Input() projectRoles: ProjectCostRole[] = [];

  /** The category the cost was opened with, so editing it without moving it is never blocked. */
  private originalCategoryId: number | null = null;

  addNewPartnerPopupVisible: boolean = false;

  addPaymentPlanVisible: boolean = true;

  @Output() selectedCategoryToSend = new EventEmitter<any>();

  @Output() onHiding = new EventEmitter<any>();

  @Output() onProjectAutoCompleted = new EventEmitter<void>();

  @ViewChild(DxFormComponent, { static: false }) form: DxFormComponent;
  @ViewChild(DxFormComponent, { static: false }) saveButton: DxButtonComponent;
  @ViewChild(ContactsPopupComponent) contactsPopup: ContactsPopupComponent;

  paymentPlanCounter: any = 0;
  todaysDate = new Date();
  currentDate = new Date();
  futuredate = new Date(this.currentDate.setMonth(this.currentDate.getMonth() + 2));

  focusedSelection: any = {};

  projectId: any = '';

  route: any = '';

  routeID: any = '';

  route2: any = '';

  route2ID: any = '';

  opened: boolean = false;

  percentage: any = $localize`:@@percentage:Percentage`;
  euro: any = $localize`:@@euro:Euro`;
  invoicesAdditionTextError: any = $localize`Sum of all invoices does not match the total cost position`;
  invoicesPercentageTextError: any = $localize`Sum of all percentages on invoices does not match the total cost position`;
  categoryRequiredMessage: any = $localize`Category is required`;
  euroReadOnly: boolean = false;
  percentReadOnly: boolean = false;
  euroReadOnlyForEdit: boolean = false;
  percentReadOnlyForEdit: boolean = false;
  contactsSelectorValidation: any = '';
  milestoneOffsetDirections: any = [
    { text: 'Before', id: 1 },
    { text: 'After', id: 2 },
  ];

  @Input() milestones: any = [];
  @Input() projectMilestones: any[] = [];
  dueDateByMilestone: boolean = false;

  doesPercentageAddUp: boolean = true;
  doesNettAddUp: boolean = true;

  totalPercentages: any = 0;
  totalNett: any = 0;

  ppCounter: number = 0;

  persons: any;
  companies: any;
  contacts: any;

  contactsPopupVisible: boolean = false;

  selectedTaskId: any;
  targetItem: any;

  allowEuroToPercentChange: boolean = true;
  targetType: any;

  constructor(
    private projectCostsService: ProjectCostsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appGlobals: AppGlobals,
    private contactService: ContactService,
    private projectCostTemplatesService: ProjectCostTemplatesService,
    private location: Location,
    private projectService: ProjectService,
    private globalPopupService: GlobalPopupService
  ) {}

  popupCol: number = this.calculateColCount(window.innerWidth);

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.popupCol = this.calculateColCount(window.innerWidth);
  }

  private calculateColCount(width: number): number {
    if (width >= 1500) return 8;
    else return 1;
  }

  ngOnInit(): void {
    this.appGlobals.ShowGlobalLoader();

    //Gets Lists for dropdowns
    let category = this.categoryList;
    this.getPartnerLists();
    this.assignTreeListIDs(category, 0, 0).then(() => {
      this.isTreeBoxOpened = false;
    });

    //Sets Project Cost data from previous page to populate the popup windows' form, sets Project ID from URL and sets display of 'close' on an invoice.

    let projectDetails = this.projectDetails;
    this.focusedSelection = projectDetails;
    this.originalCategoryId =
      this.focusedSelection.siteCost.id != null ? this.focusedSelection.siteCost.projectCostCategoryId : null;
    console.log('focusedSelection first', this.focusedSelection);

    if (this.activatedRoute.snapshot.paramMap.get('id')) {
      let id = '' + this.activatedRoute.snapshot.paramMap.get('id');
      this.projectId = parseInt(id);
      if (isNaN(this.projectId)) this.projectId = 0;
    }

    if (this.focusedSelection.paymentPlans.length > 1) this.removePaymentPlanButtonVisible = true;

    //if plan is set to type Euro and id isn't null(For new costs), the user can't change it to type percent

    if (!this.focusedSelection.siteCost.planIsPercentage && this.focusedSelection.siteCost.id != null) {
      this.allowEuroToPercentChange = false;
      setTimeout(() => {
        this.switchElement = document.getElementById('toggleSwitch');
        this.switchElement.className = 'switch switch-disabled';
      }, 100);
    }

    // Sets all relevant fields for Site Cost data and display feilds
    this.focusedSelection.siteCost.ust = this.focusedSelection.siteCost.ust / 100;
    for (let u = 0; u < this.partnerList.length; u++) {
      if (this.partnerList[u].id === this.focusedSelection.siteCost.partnerId) {
        this.focusedSelection.siteCost.PartnerName = this.partnerList[u].name;
      } else {
        this.focusedSelection.siteCost.PartnerName = '';
      }
    }

    //Does calculations to populate nessisary nett, gross and percentage feilds

    for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
      let paymentPlan = this.focusedSelection.paymentPlans[i];
      paymentPlan.costMilestoneOffset = Math.abs(paymentPlan.costMilestoneOffset);
      // A missing flag would render the checkbox in its "indeterminate" state.
      paymentPlan.invoiceAvailable = !!paymentPlan.invoiceAvailable;
      /*    if (paymentPlan.costMilestoneOffset >= 0) {
           paymentPlan.milestoneOffsetDirections = "After";
         } else {
           paymentPlan.milestoneOffsetDirections = "Before";
           paymentPlan.costMilestoneOffset = Math.abs(paymentPlan.costMilestoneOffset);
         } */

      console.log(this.focusedSelection.paymentPlans[i].planPercentage);
      //Converts plan percentage

      //this.focusedSelection.paymentPlans[i].planPercentage = this.focusedSelection.paymentPlans[i].planPercentage / 100;
      // Sets plan number for UI display on an Invoice header
      if (this.focusedSelection.paymentPlans[i].planNr === null) {
        if (this.focusedSelection.paymentPlans.length > 1) {
          this.focusedSelection.paymentPlans[i].planNr = i + 1;
        }
      }
      //Does calculations to populate nett, gross and percentage feilds in order for a Project Cost

      this.onSiteNettCostOrUstChangeOnLoad();
    }

    AppGlobals.GlobalLoaderVisible = true;
    /* setTimeout(() => { */
    // this.appGlobals.HideGlobalLoader();
    this.categoryDisabled = false;

    /*    }, 100); */
    this.calcProjectCostGross();
  }

  ngAfterContentInit(): void {}

  ngOnChanges(): void {}

  roundValuesForType(): void {
    for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
      this.totalNett += this.focusedSelection.paymentPlans[i].planCostNettValue;
      this.totalPercentages += this.focusedSelection.paymentPlans[i].planPercentageValue;
    }
    // Recalculate invoice nettcosts to add up and change last nett cost so totals add up to siteCost nett total

    if (this.totalNett != this.focusedSelection.siteCost.totalCostNett) {
      //  let nettDifference = parseFloat((this.totalNett - this.focusedSelection.siteCost.totalCostNett).toFixed(2));
      let nettDifference: any = parseFloat((this.totalNett - this.focusedSelection.siteCost.totalCostNett).toFixed(2));
      let lastPaymentPlanIndex = this.focusedSelection.paymentPlans.length - 1;
      this.focusedSelection.paymentPlans[lastPaymentPlanIndex].planCostNettValue -= nettDifference;
    }

    // Recalculate invoice percentages to add up and change last percentage so totals add up to 100(%)

    if (this.totalPercentages != 1) {
      let percentageDifference = 1 - this.totalPercentages;
      let lastPaymentPlanIndex = this.focusedSelection.paymentPlans.length - 1;
      this.focusedSelection.paymentPlans[lastPaymentPlanIndex].planPercentageValue -= percentageDifference;
    }

    this.onSiteNettCostOrUstChange();
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key.startsWith('Arrow')) {
      event.preventDefault();
    }
  }
  onWheel(event: WheelEvent): void {
    event.preventDefault();
  }

  invoiceText(i: any): any {
    return $localize`:@@invoice:Invoice`;
  }

  async assignTreeListIDs(categories: any, cat: any, subCat: any) {
    this.appGlobals.ShowGlobalLoader();
    for (let i = 0; i < categories.length; i++) {
      if (cat === 0) {
        categories[i].treeId = i + 1;
        this.treeDataSourceSorted.push(categories[i]);
      } else {
        if (subCat != 0) {
          categories[i].treeId = cat + '_' + subCat + '_' + (i + 1);
          categories[i].treeCategoryId = cat + '_' + subCat;
          this.treeDataSourceSorted.push(categories[i]);
        } else {
          this.treeDataSourceSorted.push(categories[i]);
        }
      }
      if (categories[i].subCategories.length > 0) {
        let subCategory = categories[i].subCategories;
        for (let a = 0; a < subCategory.length; a++) {
          let idlayer = '_';
          categories[i].subCategories[a].treeId = categories[i].treeId + idlayer + (a + 1);
          categories[i].subCategories[a].treeCategoryId = categories[i].treeId;
          this.treeDataSourceSorted.push(categories[i].subCategories[a]);
          if (categories[i].subCategories[a].subCategories.length > 0) {
            this.assignTreeListIDs(categories[i].subCategories[a].subCategories, i + 1, a + 1);
          }
        }
      }
    }
  }

  getSelectedID(e: any): void {
    this.onHiding.emit(false);
    this.selectedCategoryToSend.emit(e.data);
  }

  goBack(): void {
    this.onHiding.emit(false);
  }

  /** Name of the department whose project role is empty for the selected category, or null when the cost can be saved. */
  get missingRoleDepartment(): string | null {
    const categoryId = this.focusedSelection?.siteCost?.projectCostCategoryId;
    if (categoryId == null || categoryId === this.originalCategoryId) return null;
    const category = this.treeDataSourceSorted.find((c: any) => c.id === categoryId);
    return missingResponsibleDepartment(category?.departmentId, this.projectRoles);
  }

  saveAdd(event: ClickEvent): void {
    //Calculate total addition of invoices/payment plans for:  planPercentage and planCostNett
    if (!event.validationGroup.validate().isValid) return;
    const department = this.missingRoleDepartment;
    if (department) {
      AppGlobals.ShowErrorMessage(
        $localize`:@@costMissingResponsibleRoleToast:Please assign a responsible person for the department ${department}:INTERPOLATION: in the project roles first.`
      );
      return;
    }
    this.totalPercentages = 0;
    this.totalNett = 0;
    for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
      if (this.focusedSelection.paymentPlans[i].isDeleted === false) {
        // this.focusedSelection.paymentPlans[i].planPercentage = parseFloat((this.focusedSelection.paymentPlans[i].planPercentageValue).toFixed(2));
        this.totalPercentages =
          this.totalPercentages + parseFloat(this.focusedSelection.paymentPlans[i].planPercentage.toFixed(2));
        this.totalNett += parseFloat(this.focusedSelection.paymentPlans[i].planCostNett.toFixed(2));
      }
    }

    //Check if Category and Partner have been selected
    /*     if (this.focusedSelection.siteCost.projectCostCategoryId === null || this.focusedSelection.siteCost.projectCostCategoryId === '' || this.focusedSelection.siteCost.projectCostCategoryId === undefined) {
          AppGlobals.ShowErrorMessage($localize`Category is required`);
        } else {
          if (this.focusedSelection.siteCost.partnerId === null || this.focusedSelection.siteCost.partnerId === '' || this.focusedSelection.siteCost.partnerId === undefined) {
            AppGlobals.ShowErrorMessage($localize`Partner is required`);
          } else { */
    console.log('nett totals:', this.totalNett, this.focusedSelection.siteCost.totalCostNett);
    console.log('CHECK % TOTALS', parseFloat(this.totalPercentages.toFixed(2)));
    //Check if siteCost is set to type percentage or not
    if (this.focusedSelection.siteCost.planIsPercentage) {
      if (parseFloat(this.totalPercentages.toFixed(2)) != 1) {
        AppGlobals.ShowErrorMessage(this.invoicesPercentageTextError);
      } else {
        // Recalculate invoice nettcosts to add up and change last nett cost so totals add up to siteCost nett total

        const updatePaymentPlan = () => {
          if (this.totalNett != this.focusedSelection.siteCost.totalCostNett) {
            //let nettDifference = parseFloat((this.totalNett - this.focusedSelection.siteCost.totalCostNett).toFixed(2));
            let nettDifference: any = parseFloat(
              (this.totalNett - this.focusedSelection.siteCost.totalCostNett).toFixed(2)
            );
            let lastPaymentPlanIndex = this.focusedSelection.paymentPlans.length - 1;
            this.focusedSelection.paymentPlans[lastPaymentPlanIndex].planCostNett -= nettDifference;
            console.log(
              'nett lastPaymentPlanIndex:',
              this.focusedSelection.paymentPlans[lastPaymentPlanIndex].planCostNett
            );
          }
        };

        // Then do save
        const save = async () => {
          updatePaymentPlan();
          this.saveProjectCost(event);
        };
        save();
      }
    } else {
      console.log('B');
      // this.totalNett = parseFloat((this.totalNett).toFixed(2));
      this.totalNett = parseFloat(this.totalNett.toFixed(2));

      if (this.focusedSelection.siteCost.totalCostNett != this.totalNett) {
        AppGlobals.ShowErrorMessage(this.invoicesAdditionTextError);
      } else {
        // Recalculate invoice percentages to add up and change last percentage so totals add up to 100(%)
        const updatePaymentPlan = () => {
          if (this.totalPercentages != 1) {
            let percentageDifference = 1 - this.totalPercentages;
            let lastPaymentPlanIndex = this.focusedSelection.paymentPlans.length - 1;
            this.focusedSelection.paymentPlans[lastPaymentPlanIndex].planPercentage -= percentageDifference;
          }
        };

        // Then do save
        const save = async () => {
          updatePaymentPlan();
          this.saveProjectCost(event);
        };
        save();
      }
    }
  }
  /*     }
    } */

  saveProjectCost(event: any, commissionConfirmed = false): void {
    // A cost with an invoice must be commissioned - saving without "Beauftragt" is not allowed.
    // The user either marks it as commissioned and saves, or cancels and nothing is saved.
    const hasInvoice = this.focusedSelection.paymentPlans.some((pp: any) => !pp.isDeleted && pp.invoiceAvailable);
    if (!commissionConfirmed && hasInvoice && !this.focusedSelection.siteCost.beauftragt) {
      this.globalPopupService.showPopup({
        title: $localize`:@@invoiceNotCommissionedTitle:Cost not commissioned`,
        content: $localize`:@@invoiceNotCommissionedContent:An invoice is recorded for this cost, so it must be marked as commissioned before it can be saved.`,
        buttons: [
          {
            text: $localize`:@@cancel:Cancel`,
            onClick: () => {},
            type: 'tertiary-text',
          },
          {
            text: $localize`:@@invoiceNotCommissionedYes:Mark as commissioned and save`,
            onClick: () => {
              this.focusedSelection.siteCost.beauftragt = true;
              this.saveProjectCost(event, true);
            },
            type: 'primary',
          },
        ],
      });
      return;
    }

    //DO SAVE CALL

    let projectToSave = this.focusedSelection;

    projectToSave = {
      SiteCost: {
        Id: this.focusedSelection.siteCost.id,
        SiteId: this.focusedSelection.siteCost.siteId,
        ProjectCostCategoryId: this.focusedSelection.siteCost.projectCostCategoryId,
        PartnerId: this.focusedSelection.siteCost.partnerId,
        PartnerType: this.focusedSelection.siteCost.partnerType,
        DebitorId: this.focusedSelection.siteCost.debitorId,
        DebitorType: this.focusedSelection.siteCost.debitorType,
        TotalCostNett: this.focusedSelection.siteCost.totalCostNett,
        Ust: this.focusedSelection.siteCost.ust * 100,
        PlanIsPercentage: this.focusedSelection.siteCost.planIsPercentage,
        Beauftragt: this.focusedSelection.siteCost.beauftragt ?? false,
        IsDeleted: this.focusedSelection.siteCost.isDeleted,
      },
      PaymentPlans: [],
      ProjectCostSplits: [
        {
          PaymentPlanId: this.focusedSelection.projectCostSplits.paymentPlanId,
          ProjectId: this.projectId,
          ProjectPercentageSplit: 100,
        },
      ],
    };

    for (let pp = 0; pp < this.focusedSelection.paymentPlans.length; pp++) {
      console.log('WAITING', this.focusedSelection.paymentPlans);
      let pptoPush = {
        PaymentPlanId: this.focusedSelection.paymentPlans[pp].paymentPlanId,
        PlanNr: this.focusedSelection.paymentPlans[pp].planNr,
        PlanCostNett: parseFloat(this.focusedSelection.paymentPlans[pp].planCostNett?.toFixed(2) ?? '0'),
        PlanCostGross: parseFloat(this.focusedSelection.paymentPlans[pp].planCostGross?.toFixed(2) ?? '0'),
        PlanPercentage: parseFloat(
          (this.focusedSelection.paymentPlans[pp].planPercentageValue * 100)?.toFixed(2) ?? '0'
        ),
        PlanNotes: this.focusedSelection.paymentPlans[pp].planNotes,
        DiscountGross: parseFloat(this.focusedSelection.paymentPlans[pp].discountGross?.toFixed(2) ?? '0'),
        CostMilestoneDirection: this.focusedSelection.paymentPlans[pp].costMilestoneDirection,
        CostMilestoneOffset: this.focusedSelection.paymentPlans[pp].costMilestoneOffset,
        CostMilestoneId: this.focusedSelection.paymentPlans[pp].costMilestoneId,
        DueDateMilestone: this.focusedSelection.paymentPlans[pp].dueDateMilestone,
        DueDate: this.focusedSelection.paymentPlans[pp].dueDate,
        DueAmountGross: parseFloat(this.focusedSelection.paymentPlans[pp].dueAmountGross.toFixed(2) ?? '0'),
        PaidAmountGross: parseFloat(this.focusedSelection.paymentPlans[pp].paidAmountGross?.toFixed(2) ?? '0'),
        PaidDate: this.focusedSelection.paymentPlans[pp].paidDate,
        PaymentNotes: this.focusedSelection.paymentPlans[pp].paymentNotes,
        PaymentPlanIdentifier: this.focusedSelection.paymentPlans[pp].paymentPlanIdentifier,
        InvoiceAvailable: this.focusedSelection.paymentPlans[pp].invoiceAvailable ?? false,
        // An unticked box keeps the number on screen (so an accidental untick loses nothing) but it is not saved.
        InvoiceNumber: this.focusedSelection.paymentPlans[pp].invoiceAvailable
          ? this.focusedSelection.paymentPlans[pp].invoiceNumber?.trim()
          : null,
        IsDeleted: this.focusedSelection.paymentPlans[pp].isDeleted,
      };
      console.log('SUCCESS', pptoPush);
      if (!this.focusedSelection.siteCost.planIsPercentage) {
        pptoPush.PlanPercentage = parseFloat(
          (this.focusedSelection.paymentPlans[pp].planPercentageValue * 100).toFixed(2)
        );
      }

      projectToSave.PaymentPlans.push(pptoPush);
    }

    this.projectCostsService.writeProjectCost(projectToSave).then(
      result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.saveToast(result);
          this.hidePopUp();
          if (result.projectAutoCompleted) {
            this.onProjectAutoCompleted.emit();
            return;
          } else if (result.projectAlmostCompleted) {
            this.globalPopupService.showPopup({
              title: $localize`:@@projectAlmostCompleteTitle:Project almost complete`,
              content: $localize`:@@projectAlmostCompleteCostsDone:All costs have been paid. However, there are still tasks outstanding. Please complete the remaining tasks or mark them as unnecessary if you wish to complete the project.`,
              buttons: [{ text: $localize`:@@ok:Ok`, onClick: () => {}, type: 'secondary' }],
            });
          }
        }
      },
      error => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  saveToast(e: any): void {
    const type = e ? 'success' : 'error';
    var text: string = '';
    if ((this.type = 'success')) {
      text = $localize`:@@saveSuccessful:Save Successful`;
    } else {
      text = $localize`There was an error, please try again.`;
    }

    this.message = text;
    this.type = type;
    this.toastVisible = true;
    setTimeout(() => {
      this.toastVisible = false;
    }, 2000);
  }

  treeView_itemSelectionChanged(e: any) {
    if (e.itemData.subCategories.length <= 0) {
      /*       if (e.itemData.itemLevel === 1) {
              AppGlobals.ShowErrorMessage($localize`Cannot assign a Primary Category.`);
              e.itemData = null;
            } else { */
      this.focusedSelection.siteCost.projectCostCategoryId = e.itemData.id;
      this.focusedSelection.siteCost.categoryName = e.itemData.categoryName;
      this.isTreeBoxOpened = false;
      /*   } */
    } else {
      this.isTreeBoxOpened = true;
    }
  }

  async addNewPaymentPlan() {
    this.ppCounter = 0;
    this.removePaymentPlanButtonVisible = true;
    this.deleteButtonVisible = false;
    this.paymentPlanCounter = this.paymentPlanCounter + 1;
    this.calcDueOfTotal();

    await this.calcPercentagesOfTotal().then(() => {
      let paymentToAdd: any = {
        // planCostNett: parseFloat((this.focusedSelection.siteCost.totalCostNett - this.totalDueCalc).toFixed(2)),
        planCostNett: parseFloat((this.focusedSelection.siteCost.totalCostNett - this.totalDueCalc).toFixed(2)),
        planCostNettValue: parseFloat((this.focusedSelection.siteCost.totalCostNett - this.totalDueCalc).toFixed(2)),
        discountGross: 0,
        discountNett: 0,
        dueAmountGross: 0,
        dueAmountNett: 0,
        dueDate: this.futuredate,
        costMilestoneId: null,
        dueDateMilestone: null,
        costMilestoneOffset: null,
        costMilestoneDirection: '',
        paidAmountGross: 0,
        paidAmountNett: 0,
        paidDate: null,
        //paidDate: this.currentDate,
        paymentNotes: '',
        paymentPlanId: null,
        paymentPlanIdentifier: null,
        invoiceAvailable: false,
        invoiceNumber: null,
        planNotes: '',
        planNr: 0,
        //  planPercentage: parseFloat((1 - this.totalPercentageCalc).toFixed(2)),
        planPercentage: parseFloat((1 - this.totalPercentageCalc).toFixed(2)),
        planPercentageValue: parseFloat((1 - this.totalPercentageCalc).toFixed(2)),
        isDeleted: false,
      };
      paymentToAdd.planCostGross = paymentToAdd.planCostNett * (1 + this.focusedSelection.siteCost.ust);
      //  paymentToAdd.planPercentageValue = 1 - this.totalPercentageCalc;
      paymentToAdd.dueAmountNett = paymentToAdd.planCostNett - paymentToAdd.discountNett - paymentToAdd.paidAmountNett;
      paymentToAdd.dueAmountGross =
        paymentToAdd.planCostGross - paymentToAdd.discountGross - paymentToAdd.paidAmountGross;

      if (!this.focusedSelection.siteCost.planIsPercentage) {
        paymentToAdd.planPercentageValue = paymentToAdd.planPercentage;
      }
      this.focusedSelection.paymentPlans.push(paymentToAdd);
      this.roundValuesForType();
      this.addPaymentPlanVisible = true;

      this.setNewPlanNr();
    });
  }

  async calcPercentagesOfTotal() {
    this.totalPercentageCalc = 0;
    for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
      if (this.focusedSelection.paymentPlans[i].isDeleted === false) {
        this.totalPercentageCalc = this.totalPercentageCalc + this.focusedSelection.paymentPlans[i].planPercentageValue;
      }
    }
  }

  async calcDueOfTotal() {
    this.totalDueCalc = 0;
    for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
      if (this.focusedSelection.paymentPlans[i].isDeleted === false) {
        this.totalDueCalc = this.totalDueCalc + this.focusedSelection.paymentPlans[i].planCostNettValue;
      }
    }
  }

  hidePopUp(): void {
    this.goTo('projektkosten/' + this.projectId);
    this.onHiding.emit(false);
    this.isTreeBoxOpened = false;
  }

  goTo(path: string): void {
    this.router.navigate([path]);
  }

  addNewParter(e: any): void {
    this.addNewPartnerPopupVisible = true;
  }

  @Input() sizeUnit: any = '';

  formatkWP(e: any) {
    return (e + ' ' + this.sizeUnit).trim();
  }

  removePaymentPlan(e: any): void {
    this.ppCounter = 0;
    this.focusedSelection.paymentPlans[e].isDeleted = true;
    for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
      if (this.focusedSelection.paymentPlans[i].isDeleted === false) {
        this.ppCounter += 1;
      }
    }
    if (this.ppCounter <= 1) {
      this.removePaymentPlanButtonVisible = false;
    }

    this.setNewPlanNr();
  }

  setNewPlanNr(): any {
    let counter: number = 0;

    for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
      let pp = this.focusedSelection.paymentPlans[i];

      if (pp.isDeleted === false) {
        counter = counter + 1;
        pp.planNr = counter;
      }
    }
  }

  /**
   * True as soon as either contact field shows its "view contact" icon. Every field in the
   * column then reserves the icon's width, so all the inputs keep one shared right edge
   * instead of going ragged when only one of them has an icon.
   */
  get showContactIcons(): boolean {
    const siteCost = this.focusedSelection?.siteCost;
    return !!(siteCost?.partnerId || siteCost?.debitorId);
  }

  /** contactType is 'person' or 'company' — the two /contacts/:type/:id routes differ. */
  viewContact(contactId: any, contactType: string): void {
    if (contactId != null && contactId != 0 && contactType) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/contacts/' + contactType + '/' + contactId])
      );
      window.open(url, '_blank');
    }
  }

  changePartnerSelectionAdd(e: any): void {
    if (e.selectedItem != null) {
      this.focusedSelection.siteCost.partnerId = e.selectedItem.id;
      this.focusedSelection.siteCost.partnerName = e.selectedItem.displayName;
      this.focusedSelection.siteCost.partnerType = e.selectedItem.type;
    } else {
      this.focusedSelection.siteCost.partnerId = null;
      this.focusedSelection.siteCost.partnerName = '';
      this.focusedSelection.siteCost.partnerType = '';
    }
  }

  /**
   * The SAVE button validates this group and saveAdd gates on its result, so the required rules
   * have to join the same one. Shared as a field rather than repeated as a string literal in
   * three bindings: a typo in one of them is a silent no-op, not a failure anyone would see.
   */
  readonly validationGroupName = "projectCostPopUpValidationGroup";

  readonly debitorRequiredMessage = $localize`:@@debitorIsRequired:Debitor is required`;

  changeDebitorSelectionAdd(e: any): void {
    console.log('Change Debitor: ', e);
    if (e.selectedItem != null) {
      this.focusedSelection.siteCost.debitorId = e.selectedItem.id;
      this.focusedSelection.siteCost.debitorName = e.selectedItem.displayName;
      this.focusedSelection.siteCost.debitorType = e.selectedItem.type;
    } else {
      this.focusedSelection.siteCost.debitorId = null;
      this.focusedSelection.siteCost.debitorName = '';
      this.focusedSelection.siteCost.debitorType = '';
    }
  }

  switchElement: any = document.getElementById('toggleSwitch');
  toggleSwitch(): any {
    this.switchElement = document.getElementById('toggleSwitch');

    if (this.focusedSelection.siteCost.planIsPercentage) {
      this.paymentTypeSwitch('euro');
    } else {
      this.paymentTypeSwitch('percent');
    }
  }
  dateSwitchElement: any = document.getElementById('toggleDateSwitch');
  toggleDueDateSwitch(item: any, index: any): any {
    this.dateSwitchElement = document.getElementById('toggleDateSwitch');

    if (this.focusedSelection.paymentPlans[index].dueDateMilestone) {
      this.dueDateTypeSwitch('date', item, index);
    } else {
      this.dueDateTypeSwitch('milestone', item, index);
    }
  }

  dueDateTypeSwitch(e: any, item: any, index: any): void {
    if (e === 'date') {
      this.focusedSelection.paymentPlans[index].dueDateMilestone = false;
      console.log(item);
      item.dueDateMilestone = false;
      console.log(item);
    } else {
      //e = milestone
      this.focusedSelection.paymentPlans[index].dueDateMilestone = true;
      console.log(item);
      item.dueDateMilestone = true;
      console.log(item);
    }
  }

  showPopup: boolean = false;
  popupMessage: string = '';
  popupTitle: string = '';
  popupType: 'euro' | 'percent';
  skipStorageKey = 'showAlert';
  includeDontShowButton: boolean = true;
  currentSwitchValue: string = '';

  paymentTypeSwitch(e: any): void {
    const key = this.skipStorageKey;
    const skipAlert = localStorage.getItem(key) === 'false';
    this.currentSwitchValue = e;

    if (e === 'euro') {
      this.popupTitle = $localize`:@@confirm:Confirm`;
      this.popupMessage = $localize`You are about to change from Cost Type Percent to Cost Type Euro, this change CANNOT be reversed and could result in rounding adjustments altering values, are you sure you want to continue?`;
      this.popupType = 'euro';
      this.includeDontShowButton = true;
      this.showPopup = !skipAlert;
      this.paymentTypeSwitchConfirm(this.currentSwitchValue);
    } else if (e === 'percent' && this.allowEuroToPercentChange) {
      this.popupTitle = $localize`:@@confirm:Confirm`;
      this.popupMessage = $localize`Changing Cost Type could result in rounding adjustments altering values, are you sure you want to continue?`;
      this.popupType = 'percent';
      this.includeDontShowButton = true;
      this.showPopup = !skipAlert;
      this.paymentTypeSwitchConfirm(this.currentSwitchValue);
    }
  }

  confirmPopup(choice: 'yes' | 'no' | 'dontshow'): void {
    // this.showPopup = false;

    if (choice === 'yes') {
      this.paymentTypeSwitchConfirm(this.currentSwitchValue);
      this.showPopup = false;
    } else if (choice === 'dontshow') {
      // this.paymentTypeSwitchConfirm(this.currentSwitchValue);
      localStorage.setItem(this.skipStorageKey, 'false');
    }
  }

  onDontShowChanged(e: any): void {
    if (e.value === true) {
      this.confirmPopup('dontshow');
    } else {
      localStorage.removeItem(this.skipStorageKey);
    }
  }

  paymentTypeSwitchConfirm(e: any): void {
    if (e === 'percent') {
      this.focusedSelection.siteCost.planIsPercentage = true;
      this.switchElement.className = 'switch active';
      this.changeToPercentType();
      this.roundValuesForType();
    }

    if (e === 'euro') {
      this.focusedSelection.siteCost.planIsPercentage = false;
      this.switchElement.className = 'switch switch-disabled';
      this.allowEuroToPercentChange = false;
      this.changeToEuroType();
      this.roundValuesForType();
    }
  }
  // this.calcutaleGrossAmountChange(this.focusedSelection.siteCost.totalCostNett)

  // Unticking re-checks the number right away so a leftover "required" error disappears;
  // ticking stays silent until the user saves or types.
  onInvoiceAvailableChanged(item: any, validator: DxValidatorComponent): void {
    if (!item.invoiceAvailable) validator.instance.validate();
  }

  // The box follows the number while the user types: filled ticks it, cleared unticks it.
  // Programmatic changes (e.g. loading a saved cost) have no e.event and are left alone.
  onInvoiceNumberChanged(item: any, e: any): void {
    if (!e.event) return;
    item.invoiceAvailable = !!item.invoiceNumber?.trim();
  }

  // One callback per invoice so the template binding stays stable across change detection.
  private invoiceNumberValidators = new WeakMap<any, (e: any) => boolean>();

  invoiceNumberRule(item: any): (e: any) => boolean {
    let validator = this.invoiceNumberValidators.get(item);
    if (!validator) {
      validator = (e: any) => !item.invoiceAvailable || !!e.value?.trim();
      this.invoiceNumberValidators.set(item, validator);
    }
    return validator;
  }

  validateNonZero(e: any) {
    return e.value;
  }

  validatePercentageTotals(e: any) {
    if (e.value > 1) {
      return false;
    } else {
      return true;
    }
  }

  validateNettCostTotals(e: any) {
    if (this.doesNettAddUp === true) {
      return true;
    } else {
      return false;
    }
  }

  passNewPartnerId(e: any): void {
    this.focusedSelection.siteCost.partnerName = e.name;
    this.focusedSelection.siteCost.partnerId = e.id;
    this.addNewPartnerPopupVisible = false;
  }

  handleAbort(e: any): void {
    this.addNewPartnerPopupVisible = false;
  }

  deleteProjectCost(): void {
    let myAlert = custom({
      title: $localize`Delete Confirmation`,
      messageHtml: $localize`Are you sure you want to remove this Project Cost?`,
      buttons: [
        {
          text: $localize`No`,
          elementAttr: {
            class: 'gt-button gt-btn-right gt-blk-txt button-top-space add-site-icon',
            icon: 'clear',
          },
          onClick: () => {
            myAlert.show();
          },
        },
        {
          text: $localize`Yes`,
          elementAttr: {
            class: 'gt-button gt-btn-right gt-blk-txt button-top-space add-site-icon',
            icon: 'check',
          },
          onClick: () => {
            if (this.focusedSelection.siteCost.id === null) {
              this.hidePopUp();
            } else {
              let projectToSave = {
                SiteCost: {
                  Id: this.focusedSelection.siteCost.id,
                  SiteId: this.focusedSelection.siteCost.siteId,
                  ProjectCostCategoryId: this.focusedSelection.siteCost.projectCostCategoryId,
                  PartnerId: this.focusedSelection.siteCost.partnerId,
                  PartnerType: this.focusedSelection.siteCost.partnerType,
                  DebitorId: this.focusedSelection.siteCost.debitorId,
                  DebitorType: this.focusedSelection.siteCost.debitorType,
                  TotalCostNett: this.focusedSelection.siteCost.totalCostNett,
                  Ust: this.focusedSelection.siteCost.ust,
                  PlanIsPercentage: this.focusedSelection.siteCost.planIsPercentage,
                  Beauftragt: this.focusedSelection.siteCost.beauftragt ?? false,
                  IsDeleted: true,
                },
                PaymentPlans: [],
                ProjectCostSplits: [
                  {
                    PaymentPlanId: this.focusedSelection.projectCostSplits.paymentPlanId,
                    ProjectId: this.projectId,
                    ProjectPercentageSplit: 100,
                  },
                ],
              };

              for (let pp = 0; pp < this.focusedSelection.paymentPlans.length; pp++) {
                let pptoPush = {
                  PaymentPlanId: this.focusedSelection.paymentPlans[pp].paymentPlanId,
                  PlanNr: this.focusedSelection.paymentPlans[pp].planNr,
                  PlanCostNett: parseFloat((this.focusedSelection.paymentPlans[pp].planCostNett ?? 0).toFixed(2)),
                  PlanCostGross: parseFloat((this.focusedSelection.paymentPlans[pp].planCostGross ?? 0).toFixed(2)),
                  PlanPercentage: parseFloat(
                    ((this.focusedSelection.paymentPlans[pp].planPercentageValue ?? 0) * 100).toFixed(2)
                  ),
                  PlanNotes: this.focusedSelection.paymentPlans[pp].planNotes,
                  DiscountGross: parseFloat((this.focusedSelection.paymentPlans[pp].discountGross ?? 0).toFixed(2)),
                  CostMilestoneDirection: this.focusedSelection.paymentPlans[pp].costMilestoneDirection,
                  CostMilestoneOffset: this.focusedSelection.paymentPlans[pp].costMilestoneOffset,
                  CostMilestoneId: this.focusedSelection.paymentPlans[pp].costMilestoneId,
                  DueDateMilestone: this.focusedSelection.paymentPlans[pp].dueDateMilestone,
                  DueDate: this.focusedSelection.paymentPlans[pp].dueDate,
                  DueAmountGross: parseFloat((this.focusedSelection.paymentPlans[pp].dueAmountGross ?? 0).toFixed(2)),
                  PaidAmountGross: parseFloat((this.focusedSelection.paymentPlans[pp].paidAmountGross ?? 0).toFixed(2)),
                  PaidDate: this.focusedSelection.paymentPlans[pp].paidDate,
                  PaymentNotes: this.focusedSelection.paymentPlans[pp].paymentNotes,
                  PaymentPlanIdentifier: this.focusedSelection.paymentPlans[pp].paymentPlanIdentifier,
                  InvoiceAvailable: this.focusedSelection.paymentPlans[pp].invoiceAvailable ?? false,
                  // An unticked box keeps the number on screen (so an accidental untick loses nothing) but it is not saved.
                  InvoiceNumber: this.focusedSelection.paymentPlans[pp].invoiceAvailable
                    ? this.focusedSelection.paymentPlans[pp].invoiceNumber?.trim()
                    : null,
                  IsDeleted: true,
                };

                /*              if (this.focusedSelection.paymentPlans[pp].costMilestoneOffset >= 0) {
                               this.focusedSelection.paymentPlans[pp].milestoneOffsetDirections = "After";
                             } else {
                               this.focusedSelection.paymentPlans[pp].milestoneOffsetDirections = "Before";
                               this.focusedSelection.paymentPlans[pp].costMilestoneOffset = Math.abs(this.focusedSelection.paymentPlans[pp].costMilestoneOffset);
                             } */

                projectToSave.PaymentPlans.push(pptoPush);
              }

              this.projectCostsService.writeProjectCost(projectToSave).then(
                result => {
                  if (result.hasError === true) {
                    AppGlobals.ShowErrorMessage(result.feedback);
                  } else {
                    this.saveToast(result);
                    this.hidePopUp();
                    if (result.projectAutoCompleted) {
                      this.globalPopupService.showPopup({
                        title: $localize`:@@projectCompleteAutoTitle:Project complete`,
                        content: $localize`:@@projectAutoCompletedCosts:All costs have been paid and all tasks are complete. The project has been marked as complete.`,
                        buttons: [{ text: $localize`:@@ok:Ok`, onClick: () => {}, type: 'secondary' }],
                      });
                    } else if (result.projectAlmostCompleted) {
                      this.globalPopupService.showPopup({
                        title: $localize`:@@projectAlmostCompleteTitle:Project almost complete`,
                        content: $localize`:@@projectAlmostCompleteCostsDone:All costs have been paid. However, there are still tasks outstanding. Please complete the remaining tasks or mark them as unnecessary if you wish to complete the project.`,
                        buttons: [{ text: $localize`:@@ok:Ok`, onClick: () => {}, type: 'secondary' }],
                      });
                    }
                  }
                },
                error => {
                  AppGlobals.ShowErrorMessage(error);
                }
              );
            }
            myAlert.show();
          },
        },
      ],
    });
    myAlert.show();
  }

  onDropdownContactSelected(e, item) {
    if (e != null) {
      this.changePartnerSelectionAdd({
        selectedItem: { id: e.data.id, name: e.data.displayName, type: e.type },
      });
    } else {
      this.changePartnerSelectionAdd({
        selectedItem: null,
      });
    }
  }

  onDropdownDebitorContactSelected(e, item) {
    console.log('e.data', e.data);
    if (e != null) {
      this.changeDebitorSelectionAdd({
        selectedItem: { id: e.data.id, name: e.data.displayName, type: e.type },
      });
    } else {
      this.changeDebitorSelectionAdd({
        selectedItem: null,
      });
    }
  }

  getPartnerLists(): void {
    this.appGlobals.ShowGlobalLoader();
    this.contactService.getCompanies({}).then(
      result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.companies = result.companyItems;

          this.contactService.getPersons({}).then(
            result => {
              if (result.hasError === true) {
                AppGlobals.ShowErrorMessage(result.feedback);
              } else {
                this.persons = result.personItems;
                this.contacts = this.companies.concat(this.persons);
              }
            },
            error => {
              AppGlobals.ShowErrorMessage(error);
            }
          );
        }
      },
      error => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  showContactsPopup(id) {
    this.selectedTaskId = id;
    this.contactsPopupVisible = true;
  }

  onNewContactFromDropdown(type: string, data: any, targetType: 'partner' | 'debitor'): void {
    this.setPopupReturnTarget(data, targetType);
    this.showContactsPopup(data.id);
    if (this.contactsPopup) {
      this.contactsPopup.popupSelectedTab = type === 'person' ? 1 : 0;
      this.contactsPopup.editMode = true;
      this.contactsPopup.openedDirectlyInEditMode = true;
    }
  }

  setPopupReturnTarget(item, type): void {
    this.targetType = type;
    this.targetItem = item;
  }

  onPopupContactSelected(e) {
    this.targetItem.taskResult = e.data.id;
    this.targetItem.resultType = e.type;
    this.contactsPopupVisible = false;
    if (this.targetType === 'partner') {
      this.changePartnerSelectionAdd({
        selectedItem: { id: e.data.id, name: e.data.displayName, type: e.type },
      });
    }
    if (this.targetType == 'debitor') {
      this.changeDebitorSelectionAdd({
        selectedItem: { id: e.data.id, name: e.data.displayName, type: e.type },
      });
    }
  }

  onNewContactSelected(e) {
    this.targetItem.taskResult = e.id;
    this.targetItem.resultType = e.type;

    if (e.type === 'company') {
      this.contactService.getCompanies({}).then(result => {
        this.companies = result.companyItems;
        this.contactsPopupVisible = false;
        for (let i = 0; i < this.companies.length; i++) {
          if (this.companies[i].id == e.id) {
            e.displayName = this.companies[i].displayName;

            if (this.targetType === 'partner') {
              this.focusedSelection.siteCost.partnerName = e.displayName;
              this.changePartnerSelectionAdd({
                selectedItem: {
                  id: e.id,
                  displayName: e.displayName,
                  type: e.type,
                },
              });
            }
            if (this.targetType == 'debitor') {
              this.focusedSelection.siteCost.debitorName = e.displayName;
              this.changeDebitorSelectionAdd({
                selectedItem: {
                  id: e.id,
                  displayName: e.displayName,
                  type: e.type,
                },
              });
            }
          }
        }
      });
    }

    if (e.type === 'person') {
      this.contactService.getPersons({}).then(result => {
        this.persons = result.personItems;
        this.contactsPopupVisible = false;

        for (let i = 0; i < this.persons.length; i++) {
          if (this.persons[i].id == e.id) {
            e.displayName = this.persons[i].displayName;
            if (this.targetType === 'partner') {
              this.focusedSelection.siteCost.partnerName = e.displayName;
              this.changePartnerSelectionAdd({
                selectedItem: {
                  id: e.id,
                  displayName: e.displayName,
                  type: e.type,
                },
              });
            }
            if (this.targetType == 'debitor') {
              this.focusedSelection.siteCost.debitorName = e.displayName;
              this.changeDebitorSelectionAdd({
                selectedItem: {
                  id: e.id,
                  displayName: e.displayName,
                  type: e.type,
                },
              });
            }
          }
        }
      });
    }
  }

  changeMilestone(e: any): void {
    console.log(e);
    // this.selectedTemplateCost.costMilestoneId = e.selectedItem.itemId;
    // this.selectedTemplateCost.costMilestoneName = e.selectedItem.itemName;
  }

  getMilestonePlannedDate(milestoneId: number): string | null {
    const pm = this.projectMilestones.find(pm => pm.milestoneId === milestoneId);
    return pm?.dueDate ?? null;
  }

  openDocumentURL(url: any) {
    window.open(url, '_blank');
  }
  doChange(e: any) {}

  /////////////////////////////////////////////////////////////////////////////
  ///NEW PROJECT COST CALCULATIONS TO FIX (HOPEFULLY) THE ROUNDING ISSUES
  /////////////////////////////////////////////////////////////////////////////

  //GENERAL CALCULATION TO GET SITE COST AT A GROSS LEVEL
  calcProjectCostGross(): void {
    let totalCostGross = this.focusedSelection.siteCost.totalCostNett * (1 + this.focusedSelection.siteCost.ust);

    this.focusedSelection.siteCost.totalCostGross = parseFloat(totalCostGross.toFixed(2));
  }

  onSiteNettCostOrUstChangeOnLoad(): void {
    this.calcProjectCostGross();
    if (this.focusedSelection.siteCost.planIsPercentage) {
      for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
        if (this.focusedSelection.paymentPlans.length === 1) {
        } else {
        }
        this.calcPlanCostNett(i);
        this.calcPlanCostGross(i);
        //  this.calcPlanPercentageDisplay(i);
        this.calcDiscountNett(i);
        this.calcOutstandingAmounts(i);
      }
    } else {
      for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
        console.log('FOR EURO', this.focusedSelection);

        if (this.focusedSelection.paymentPlans.length === 1) {
          /*  this.calcPlanCostNett(i); */
          this.calcDiscountNett(i);
          this.calcPlanPercentageDisplay(i);

          this.calcPlanCostGross(i);
          this.calcOutstandingAmounts(i);
        } else {
          this.calcDiscountNett(i);
          this.calcPlanPercentageDisplayForEuroCost(i);
          // this.calcPlanPercentageDisplay(i);
          this.calcPlanCostGross(i);
          this.calcOutstandingAmounts(i);
        }
      }
    }
  }

  onSiteNettCostOrUstChange(): void {
    this.calcProjectCostGross();
    if (this.focusedSelection.siteCost.planIsPercentage) {
      for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
        this.calcPlanCostNett(i);
        this.calcPlanCostGross(i);
        this.calcPlanPercentageDisplayForPercentageCost(i);
        this.calcDiscountNett(i);
        this.calcOutstandingAmounts(i);
      }
    } else {
      for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
        if (this.focusedSelection.paymentPlans.length === 1) {
          this.calcPlanCostNett(i);
        }
        console.log('FOR EURO', this.focusedSelection);
        //  this.calcPlanPercentageDisplay(i);
        this.calcDiscountNett(i);
        this.calcPlanPercentageDisplayForEuroCost(i);
        this.calcPlanCostGross(i);
        this.calcOutstandingAmounts(i);
      }
    }
  }

  //RUNS CALCULATIONS WHEN COST TYPE IS SET TO PERCENT
  async changeToPercentType() {
    this.onSiteNettCostOrUstChange();

    /*     for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
          if (this.focusedSelection.paymentPlans[i].isDeleted === false) {
            this.calcPlanCostNett(i);
            this.calcPlanCostGross(i);
            this.calcPlanPercentageDisplay(i);
          }
        } */
  }

  /* 
    When a Project cost is set to type Percent: 
    - NB: User is concerned more with percentage values than Euro values.
    - Invoices' Total Due (Nett) needs to be calculated from Nett Cost * invoices' percent (To get the actual value of Total Due (Nett)).
    - Total Due (Nett) value needs to be rounded for display(and sent to API in that variable).
    - Once Total Nett Due value has been rounded, the Invoices' percentage value needs to be 'reverse' calculated based on the Nett Cost of 
    the overall project Cost (So we'll have a percentage display that has been rounded and a percentage value which will be acurate to multiple decimal values)
    - Total Due (Gross) will get calculated based on Total Nett Due value * 1,VAT%.
    - The outstanding amounts will get calculated using the paid amount values, the VAT value and the discount values deducted from the Total Due (Nett) value.
    - On saving, we need to check for rounding incositencies. And either add or remove them from the Total Due (Nett) value (And recalculate Total Due (gross) value). 
    This means the last inovice on a payment plan may change by a few cents that don't correspond exactly to the maths, but the user has chosen to make this a 
    percentage cost, which means they are concerned with percentage values primarily, and the euro values are purely for display purposes.
   
   
  */
  /// ALL CALCULATIONS FOR IF COST IS A PERCENT COST TYPE
  calcPlanCostNett(index: any): void {
    if (this.focusedSelection.siteCost.planIsPercentage) {
      this.focusedSelection.paymentPlans[index].planCostNettValue = parseFloat(
        (
          this.focusedSelection.siteCost.totalCostNett * this.focusedSelection.paymentPlans[index].planPercentage
        ).toFixed(2)
      );
      this.focusedSelection.paymentPlans[index].planCostNett =
        this.focusedSelection.paymentPlans[index].planCostNettValue;
    } else {
      this.focusedSelection.paymentPlans[index].planCostNettValue =
        this.focusedSelection.siteCost.totalCostNett * this.focusedSelection.paymentPlans[index].planPercentage;
      this.focusedSelection.paymentPlans[index].planCostNett = parseFloat(
        this.focusedSelection.paymentPlans[index].planCostNettValue.toFixed(2)
      );
    }
  }

  calcPlanCostGross(index: any): void {
    if (this.focusedSelection.siteCost.planIsPercentage) {
      this.focusedSelection.paymentPlans[index].planCostGross =
        parseFloat(
          (this.focusedSelection.siteCost.totalCostNett * (1 + this.focusedSelection.siteCost.ust)).toFixed(2)
        ) * this.focusedSelection.paymentPlans[index].planPercentage;
    } else {
      //   this.focusedSelection.paymentPlans[index].planCostGross = parseFloat((this.focusedSelection.paymentPlans[index].planCostNett * (1 + this.focusedSelection.siteCost.ust)).toFixed(2));
      this.focusedSelection.paymentPlans[index].planCostGross = parseFloat(
        (this.focusedSelection.paymentPlans[index].planCostNett * (1 + this.focusedSelection.siteCost.ust)).toFixed(2)
      );
    }
  }

  calcOutstandingAmounts(index: any): void {
    //Makes sure values don't return NaN
    if (
      this.focusedSelection.paymentPlans[index].planCostNett == null ||
      this.focusedSelection.paymentPlans[index].planCostNett == undefined
    )
      this.focusedSelection.paymentPlans[index].planCostNett = 0;
    if (
      this.focusedSelection.paymentPlans[index].discountNett == null ||
      this.focusedSelection.paymentPlans[index].discountNett == undefined
    )
      this.focusedSelection.paymentPlans[index].discountNett = 0;
    if (
      this.focusedSelection.paymentPlans[index].paidAmountNett == null ||
      this.focusedSelection.paymentPlans[index].paidAmountNett == undefined
    )
      this.focusedSelection.paymentPlans[index].paidAmountNett = 0;

    //CalculatePaidAmountNett first:
    this.calcPaidAmountNett(index);
    //Calculate outstanding values
    if (this.focusedSelection.siteCost.planIsPercentage) {
      this.focusedSelection.paymentPlans[index].dueAmountNett =
        this.focusedSelection.paymentPlans[index].planCostNettValue -
        this.focusedSelection.paymentPlans[index].discountNett -
        this.focusedSelection.paymentPlans[index].paidAmountNett;
      this.focusedSelection.paymentPlans[index].dueAmountGross =
        this.focusedSelection.paymentPlans[index].planCostGross -
        this.focusedSelection.paymentPlans[index].discountGross -
        this.focusedSelection.paymentPlans[index].paidAmountGross;
    } else {
      this.focusedSelection.paymentPlans[index].dueAmountNett =
        this.focusedSelection.paymentPlans[index].planCostNett -
        this.focusedSelection.paymentPlans[index].discountNett -
        this.focusedSelection.paymentPlans[index].paidAmountNett;
      this.focusedSelection.paymentPlans[index].dueAmountGross =
        this.focusedSelection.paymentPlans[index].planCostGross -
        this.focusedSelection.paymentPlans[index].discountGross -
        this.focusedSelection.paymentPlans[index].paidAmountGross;
    }
  }

  calcPlanPercentageDisplay(index: any): void {
    if (!this.focusedSelection.siteCost.planIsPercentage) {
      this.focusedSelection.paymentPlans[index].planPercentage =
        this.focusedSelection.paymentPlans[index].planPercentageValue;
    } else {
      this.focusedSelection.paymentPlans[index].planPercentageValue =
        this.focusedSelection.paymentPlans[index].planCostNettValue / this.focusedSelection.siteCost.totalCostNett;
      this.focusedSelection.paymentPlans[index].planPercentage =
        this.focusedSelection.paymentPlans[index].planCostNett / this.focusedSelection.siteCost.totalCostNett;
    }
  }

  calcPaidAmountNett(index: any): void {
    this.focusedSelection.paymentPlans[index].paidAmountNett =
      this.focusedSelection.paymentPlans[index].paidAmountGross / (1 + this.focusedSelection.siteCost.ust);
  }

  calcPlanPercentageDisplayForEuroCost(index: any): void {
    this.focusedSelection.paymentPlans[index].planPercentage =
      this.focusedSelection.paymentPlans[index].planCostNett / this.focusedSelection.siteCost.totalCostNett;
    if (isNaN(this.focusedSelection.paymentPlans[index].planPercentage))
      this.focusedSelection.paymentPlans[index].planPercentage = 0;
    this.focusedSelection.paymentPlans[index].planPercentageValue =
      this.focusedSelection.paymentPlans[index].planPercentage;
  }

  calcPlanPercentageDisplayForPercentageCost(index: any): void {
    this.focusedSelection.paymentPlans[index].planPercentageValue =
      this.focusedSelection.paymentPlans[index].planCostNett / this.focusedSelection.siteCost.totalCostNett;
  }

  calcDiscountNett(index: any): void {
    this.focusedSelection.paymentPlans[index].discountNett =
      this.focusedSelection.paymentPlans[index].discountGross / (1 + this.focusedSelection.siteCost.ust);
  }

  calcOnDiscountChange(index: any): void {
    this.calcDiscountNett(index);
    this.calcOutstandingAmounts(index);
  }

  calcOnPaidChanged(index: any): void {
    this.focusedSelection.paymentPlans[index].paidAmountNett =
      this.focusedSelection.paymentPlans[index].paidAmountGross / (1 + this.focusedSelection.siteCost.ust);
    this.calcOutstandingAmounts(index);
    if (
      this.focusedSelection.paymentPlans[index].paidDate === null &&
      this.focusedSelection.paymentPlans[index].paidAmountGross > 0
    )
      this.focusedSelection.paymentPlans[index].paidDate = this.todaysDate;
    if (this.focusedSelection.paymentPlans[index].paidAmountGross === 0)
      this.focusedSelection.paymentPlans[index].paidDate = null;
  }

  onPlanPercentageChange(index: any): void {
    if (this.focusedSelection.siteCost.planIsPercentage) {
      this.onSiteNettCostOrUstChange();
    }
  }

  //RUNS CALCULATIONS WHEN COST TYPE IS SET TO EURO.
  async changeToEuroType() {
    this.onSiteNettCostOrUstChange();

    /*     for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
          if (this.focusedSelection.paymentPlans[i].isDeleted === false) {
            this.calcPlanCostNett(i);
            this.calcPlanCostGross(i);
            this.calcPlanPercentageDisplay(i);
          }
        } */
    /*    
    
    
        for (let i = 0; i < this.focusedSelection.paymentPlans.length; i++) {
          if (this.focusedSelection.paymentPlans[i].isDeleted === false) {
            //  Nett value limited by UI to only allow 2 decimals so doesn't need to be rounded and claculated like the percentage does
            this.focusedSelection.paymentPlans[i].planCostNett = parseFloat((this.focusedSelection.paymentPlans[i].planCostNettValue).toFixed(2));
            // need to calculate the  percentages from Nett value
            this.focusedSelection.paymentPlans[i].planPercentage = this.focusedSelection.paymentPlans[i].planCostNett / this.focusedSelection.siteCost.totalCostNett;
            this.focusedSelection.paymentPlans[i].planPercentageValue = this.focusedSelection.paymentPlans[i].planPercentage;
          }
        } */
  }

  /*
    When a Project cost is set to type Euro:
        - NB: User is concerned more with Euro values than Euro values.
        - Invoices' planPercentages need to be calculate from the: Total Due (Nett) / Total Project Cost Nett;
        -  
    
      */

  //////////

  calcPlanPercentage(index: any): void {
    //  this.focusedSelection.paymentPlans[index].planPercentage = parseFloat(this.focusedSelection.paymentPlans[index].planPercentageValue.toFixed(2));
    this.focusedSelection.paymentPlans[index].planPercentage = parseFloat(
      this.focusedSelection.paymentPlans[index].planPercentageValue.toFixed(2)
    );
  }

  changePercentagesForEuroCostOnPlanCostNettChange(index: any): void {
    // this.focusedSelection.paymentPlans[index].planPercentageValue = parseFloat((this.focusedSelection.paymentPlans[index].planCostNettValue / this.focusedSelection.siteCost.totalCostNett).toFixed(2));;
    this.focusedSelection.paymentPlans[index].planPercentageValue =
      this.focusedSelection.paymentPlans[index].planCostNett / this.focusedSelection.siteCost.totalCostNett;

    this.focusedSelection.paymentPlans[index].planPercentage = parseFloat(
      this.focusedSelection.paymentPlans[index].planPercentageValue.toFixed(2)
    );
  }

  onPlanCostNettChanged(index: any): void {
    this.focusedSelection.paymentPlans[index].planCostNettValue =
      this.focusedSelection.paymentPlans[index].planCostNett;

    if (!this.focusedSelection.siteCost.planIsPercentage) {
      this.changePercentagesForEuroCostOnPlanCostNettChange(index);
      this.calcPlanCostGross(index);
      this.calcOutstandingAmounts(index);
    }
    //this.onSiteNettCostOrUstChange();
  }

}
